import React, { Fragment } from "react"

import supportTopics from "@/data/support-topics"
import {
  Link,
  useI18next,
  useTranslation,
} from "@zestia/gatsby-plugin-react-i18next"

const SupportTopicSidebarNav = ({ articles }) => {
  const { t } = useTranslation()
  const { originalPath } = useI18next()

  // eg. /support/setup-and-configuration/getting-started
  const pathRegex = /\/([^/]+)\/([^/]+)?\/([^/]+)?\/?$/

  const sections = pathRegex.exec(originalPath)

  // eg. setup-and-configuration
  const activeTopic = sections[2]

  // eg. getting-started
  const activeArticle = sections[3]

  const isActiveArticle = article => {
    return (
      activeArticle &&
      pathRegex.exec(article.slug.current)?.[3] === activeArticle
    )
  }

  return (
    <nav className="sidebar-menu support-topic-sidebar-nav">
      {supportTopics
        .filter(topic => !topic.hidden)
        .map(topic => {
          if (topic.id === activeTopic) {
            return (
              <Fragment key={topic.id}>
                <Link to={`/support/${topic.id}`}>
                  <h2 className="h6 sidebar-menu__title sidebar-menu__title--active">
                    {t(`support.topic.${topic.id}.name`)}
                  </h2>
                </Link>

                <ul className="sidebar-menu__mega-menu sidebar-menu__mega-menu--active">
                  {articles.map(article => {
                    return (
                      <Link
                        key={article.slug.current}
                        to={article.slug.current}
                        className={`sidebar-menu__link ${
                          isActiveArticle(article)
                            ? "support-topic-sidebar-nav__link--active"
                            : ""
                        }`}
                      >
                        {article.title}
                      </Link>
                    )
                  })}
                </ul>
              </Fragment>
            )
          }

          return (
            <Link to={`/support/${topic.id}`} key={topic.id}>
              <h2 className="h6 sidebar-menu__title">
                {t(`support.topic.${topic.id}.name`)}
              </h2>
            </Link>
          )
        })}
    </nav>
  )
}

export default SupportTopicSidebarNav
